/**
 * Portal
 * The ISC Portal is designed as an entrypoint for ISC to publish solutions to multiple cloud providers that are consumed by external users.  On this page, Swagger UI is already pre-authorised with your current JWT token and you can explore and try out APIs with your current user\'s credentials.  <code> !!! WARNING !!! Any command you issue from this page or using API calls will take an immediate effect on your deployments and data without any further confirmations. Please be very careful with POST and DELETE commands. </code>  If you want to use those APIs programmatically, you need to get JWT token first because it has a very limited expiration time.  There are multiple options to get JWT token from Amazon Cognito which our Cloud Portal use, the simplest one is to use curl and jq commands:  <code> TOKEN=$(curl -s \"https://cognito-idp.us-east-2.amazonaws.com/\" \\ -X POST \\ -d \'{\"AuthFlow\":\"USER_PASSWORD_AUTH\",\"ClientId\":\"76d6suqpq97v4fnvbg5oemieo9\",\"AuthParameters\":{\"USERNAME\":\"<USERNAME>\",\"PASSWORD\":\"<PASSWORD>\"}}\' \\ -H \"content-type: application/x-amz-json-1.1\" \\ -H \"X-Amz-Target: AWSCognitoIdentityProviderService.InitiateAuth\" | jq -r \'.AuthenticationResult.IdToken\'  ) </code>  After you get the token, you can use it to authenticate with InterSystems Cloud Portal, for example:  <code> curl \'https://portal.live.isccloud.io/v3/api/deployments\' \\ -X \'GET\' \\ -H \'accept: application/json\' \\ -H \"Authorization: Bearer $TOKEN\" </code> 
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: portal-dev@intersystems.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DirectConnectAttachmentConfiguration } from './directConnectAttachmentConfiguration';
import { VPNAttachmentConfiguration } from './vPNAttachmentConfiguration';
import { VPCAttachmentConfiguration } from './vPCAttachmentConfiguration';


/**
 * The object schema for CreateAttachmentObject
 */
export interface CreateAttachmentObject { 
    attachmenttype?: CreateAttachmentObject.AttachmenttypeEnum;
    configuration?: VPNAttachmentConfiguration | VPCAttachmentConfiguration | DirectConnectAttachmentConfiguration;
}
export namespace CreateAttachmentObject {
    export type AttachmenttypeEnum = 'vpn' | 'vpc' | 'directconnect';
    export const AttachmenttypeEnum = {
        Vpn: 'vpn' as AttachmenttypeEnum,
        Vpc: 'vpc' as AttachmenttypeEnum,
        Directconnect: 'directconnect' as AttachmenttypeEnum
    };
}


